import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Attachment from "./../../commonComponents/attachmentView";
import Survey from "./../../commonComponents/surveyView";
import SurveyCompletedScreen from "./../../commonComponents/surveyView/surveyCompleted";
import getLabel from './../../../utils/labels'
import replyIcon from "./../../../globals/images/replyicon.svg";
import selectedStar from "./../../../globals/images/star_selected.png";
import unselectedStar from "./../../../globals/images/star_unselected.svg";
import { Link } from "react-router-dom";
import styles from "./mailItem.module.scss";

class MailItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isAttachmentOpen: false,
			isSurveyOpen: false,
			mailStarredFlag: props.isStarred
		};
	}

	componentWillReceiveProps = nextProps => {
		this.setState({
			mailStarredFlag: this.isMailStarred(nextProps.lastMail)
		});
	};

	showShowMoreIcon(refElement) { }

	getSurveyCompletedFlag = () => {
		const { actionThread } = this.props;
		return actionThread.some(action => action.type === "survey");
	};

	getMailDraft = () => {
		const { actionThread } = this.props;
		return actionThread.some(action => action.type === "draft");
	};

	onMailLinkClickHandler = () => {
		const { mailIndex, tutorial } = this.props;
		if (!this.isRead) {
			this.props.addMailReadFlag(this.props.lastMail.id);
		}
		this.props.setCurrentMailIndex(mailIndex);

		//If in tutorial mode, set new steps- for inside mail
		if (tutorial.isRunning) {
			this.props.addStepsToTutorial(this.props.mailSequence, "mail");
			// this.props.updateStepNumber(0);
			setTimeout(() => {
				// this.props.startTutorial();
				this.props.updateStepNumber(0);
			}, 1000);
		}
	};

	onPdfClick = e => {
		e.preventDefault();
		e.stopPropagation();
		this.openAttachment();
	};

	onSurveyClick = e => {
		e.preventDefault();
		e.stopPropagation();
		this.openSurvey();
	};

	openAttachment = () => {
		this.setState({ isAttachmentOpen: true });
	};

	closeAttachment = () => {
		this.setState({ isAttachmentOpen: false });
	};

	openSurvey = () => {
		this.setState({ isSurveyOpen: true });
	};

	closeSurvey = () => {
		this.setState({ isSurveyOpen: false });
	};

	checkSurveyTerminatedFlag = () => {
		return this.props.actionThread.some(
			action => action.type === "call_terminated"
		);
	};

	isMailStarred = props => {
		const { actionThread } = props;

		return actionThread.some(
			action => action.type === "starred" && action.status === true
		);
	};

	getBody = body => {
		let tempBody = body.join(" ");
		return tempBody.replace(/<\/?[^>]+(>|$)/g, "");
	};

	getFromActor = () => {
		const { from, actors } = this.props;

		let actorDetails =
			actors.clients.find(actor => actor.id === from) ||
			actors.inActors.find(actor => actor.id === from);
		if (actorDetails) {
			return actorDetails.first_name + " " + actorDetails.last_name;
		}
		return from;
	};

	starClickHandler = e => {
		e.preventDefault();
		e.stopPropagation();
		const { addMailStarredFlag, removeMailStarredFlag, id } = this.props;
		if (!this.isMailStarred(this.props.lastMail)) {
			addMailStarredFlag(this.props.lastMail.id);
		} else {
			removeMailStarredFlag(this.props.lastMail.id);
		}
	};

	render() {
		const {
			id,
			mailIndex,
			replies,
			subject,
			body,
			info,
			survey,
			type,
			isImportant,
			displayTime,
			isRead
		} = this.props;
		let { isAttachmentOpen, mailStarredFlag, isSurveyOpen } = this.state;
		const isReadStyle = {
			backgroundColor: "#ededf1"
		};
		const textStyle = {
			fontWeight: "unset"
		};

		let mailDraftFlag = this.getMailDraft();

		let mailLink = this.props.tutorial.isRunning
			? `/tutorial/${id}`
			: `/mails/${id}`;

		return (
			<Fragment>
				<Link
					to={mailLink}
					className={styles.container}
					onClick={this.onMailLinkClickHandler}
				>
					<div
						className={styles.wrapper}
						style={isRead ? isReadStyle : {}}
						id={`${styles.wrapper}${mailIndex}`}
					>
						<div
							className={
								this.props.tutorial.stepIndex == 6 &&
									mailIndex === 1
									? styles["animationContainer-ripple"]
									: styles.animationContainer
							}
						>
							<div
								className={styles.icon}
								id={`${styles.wrapper}star${mailIndex}`}
								onClick={this.starClickHandler}
							>
								{mailStarredFlag ? (
									<img src={selectedStar} />
								) : (
										<img src={unselectedStar} />
									)}
							</div>
							<div
								style={isRead ? textStyle : {}}
								className={styles.from}
							>
								{this.getFromActor()}
								{isImportant ? (
									<div className={styles.imp}>{getLabel('label_important_tag')}</div>
								) : null}
								{mailDraftFlag ? (
									<div className={styles.draft}>{getLabel('label_draft_tag')}</div>
								) : null}
							</div>
							<div className={styles.text}>
								<div className={styles.subject}>
									{replies > 0 ? (
										<div className={styles.replies}>
											<img
												src={replyIcon}
												style={{
													marginRight: "5px"
												}}
											/>
											<div
												className={styles.numberOfMails}
											>
												{replies + 1}
											</div>
										</div>
									) : null}
									<div
										className={styles.title}
										style={isRead ? textStyle : {}}
									>
										{subject}
									</div>
									<div className={styles.body}>
										{this.getBody(body)}
									</div>
								</div>
								{this.props.attachments ? (
									<div
										className={styles.pdflink}
										onClick={this.onPdfClick}
									>
										<div className={styles.pdftype}>
											{getLabel('label_pdf_tag')}
										</div>
										<div className={styles.pdfname}>
											{this.props.attachments[1]}
										</div>
									</div>
								) : null}
								{type === "survey" ? (
									<div
										className={styles.pdflink}
										onClick={this.onSurveyClick}
									>
										<div className={styles.pdftype}>
											{getLabel('label_survey_tag')}
										</div>
										<div className={styles.pdfname}>
											{this.props.survey.name}
										</div>
									</div>
								) : null}
								{/* <p className={styles.desc}>{body.join(" ")}</p> */}
							</div>
							<div className={styles.time}>
								{displayTime / 60 >= 1 ? (
									<p>
										{" "}
										{(
											"0" + Math.floor(displayTime / 60)
										).slice(-2)}{" "}
										{getLabel('label_time_received_at')}{" "}
									</p>
								) : (
										<div>{getLabel('label_just_now')}</div>
									)}
							</div>
						</div>
					</div>
					<div className={styles.line} />
				</Link>
				{isAttachmentOpen ? (
					<Attachment
						src={this.props.attachments[0]}
						closeAttachment={this.closeAttachment}
					/>
				) : null}
				{isSurveyOpen && !this.checkSurveyTerminatedFlag() ? (
					<Survey
						primaryMailId={id}
						actionThread={this.props.actionThread}
						survey={survey}
						closeSurvey={this.closeSurvey}
						setSurveyCompleteFlag={this.props.setSurveyCompleteFlag}
						getTimeData={this.props.getTimeData}
						autoSaveSurveyAnswers={this.props.autoSaveSurveyAnswers}
					/>
				) : null}
				{isSurveyOpen && this.checkSurveyTerminatedFlag() ? (
					<SurveyCompletedScreen
						closeSurvey={this.closeSurvey}
						text={getLabel('label_survey_already_submitted')}
					/>
				) : null}
			</Fragment>
		);
	}
}

export default MailItem;



// WEBPACK FOOTER //
// /src/components/mailList/mailItem/MailItem.js